import { Component } from '@angular/core';

@Component({ 
  template: require('./api-docs.component.html'),
  styles: [require('./api-docs.component.scss')]
})
export class ApiDocsComponent {
  ngOnInit() {
    window.location.href = 'https://linescape-downloads.s3.amazonaws.com/schedule-api/latest/index.html';
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/api-docs/api-docs.component.ts